import gql from "graphql-tag"

const SOCIALS_DISCOVERY_RUN = gql`
  mutation socialsDiscoveryRun($socialsDiscoveryRunInput: SocialsJobRunInput!) {
    socialsDiscoveryRun(socialsDiscoveryRunInput: $socialsDiscoveryRunInput) {
      status
      message
      jobId
      runId
    }
  }
`

export default SOCIALS_DISCOVERY_RUN
